// extracted by mini-css-extract-plugin
export var swiperDesktop = "Swiper-module--swiperDesktop--72fea";
export var swiperMobile = "Swiper-module--swiperMobile--0dcf6";
export var swiperTablet = "Swiper-module--swiperTablet--8f25a";